
















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AvatarHeader extends Vue {
    @Prop() readonly textIntro
    @Prop() readonly link!: string
    @Prop() readonly linkLabel
    @Prop() readonly textOutro

    get avatarSrc(): string {
        return require('@/assets/img/avatar/' + this.$currentCompany.virtualColleagueAvatar + '.jpg')
    }
}
